import React from "react";
import { Label, Line, Wrapper } from "./TextDivider.styles";
import type { TextDividerProps } from "./TextDivider.types";

/** A rule on each side of centred text ("or", "or continue with"). */
export const TextDivider: React.FC<TextDividerProps> = ({
  text = "or",
  appearance = "legacy",
}) => (
  <Wrapper $appearance={appearance} data-appearance={appearance}>
    <Line $appearance={appearance} />
    <Label $appearance={appearance}>{text}</Label>
    <Line $appearance={appearance} />
  </Wrapper>
);

export default TextDivider;
